if (!customElements.get('quick-comparison-table')) {
  customElements.define(
    'quick-comparison-table',
    class QuickComparisonTable extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('quick-comparison-table');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.initNavigation();
            }

            if (recommendations.querySelector('.quick-comparison-table-container')) {
              this.dispatchEvent(new CustomEvent('quick-comparison-table:loaded'));
            } else {
              this.closest('.shopify-section').remove();
              this.dispatchEvent(new CustomEvent('quick-comparison-table:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      initNavigation() {
        const container = this.querySelector('.quick-comparison-table-container');
        const prevBtn = this.querySelector('.quick-comparison-nav--prev');
        const nextBtn = this.querySelector('.quick-comparison-nav--next');
        
        if (!container || !prevBtn || !nextBtn) return;

        const table = container.querySelector('.quick-comparison-table');
        if (!table) return;

        // Calculate scroll step (width of one product column)
        const getScrollStep = () => {
          const productCol = table.querySelector('td:nth-child(2)');
          return productCol ? productCol.offsetWidth : 200;
        };

        // Update button states
        const updateButtonStates = () => {
          const isAtStart = container.scrollLeft <= 10;
          const isAtEnd = container.scrollLeft >= container.scrollWidth - container.clientWidth - 10;
          
          prevBtn.disabled = isAtStart;
          nextBtn.disabled = isAtEnd;
          
          // Hide buttons if no scrolling needed
          const needsScrolling = container.scrollWidth > container.clientWidth;
          prevBtn.style.display = needsScrolling ? 'flex' : 'none';
          nextBtn.style.display = needsScrolling ? 'flex' : 'none';
        };

        // Navigation event handlers
        prevBtn.addEventListener('click', () => {
          container.scrollBy({
            left: -getScrollStep(),
            behavior: 'smooth'
          });
        });

        nextBtn.addEventListener('click', () => {
          container.scrollBy({
            left: getScrollStep(),
            behavior: 'smooth'
          });
        });

        // Update button states on scroll
        container.addEventListener('scroll', updateButtonStates);
        
        // Update on resize
        window.addEventListener('resize', updateButtonStates);

        // Initial update
        setTimeout(updateButtonStates, 100);
      }
    }
  );
}
